export default __webpack_public_path__ + "static/media/blog5_image.a136ee94.png";